// A machine's Alerts row draws the machine: a cube for a workspace machine, a laptop otherwise.
export type MachineKind = "personal" | "workspace";

export const MACHINE_AVATAR: Readonly<Record<MachineKind, string>> = {
  personal: "/machine-avatars/personal.png",
  workspace: "/machine-avatars/workspace.png",
};

// The daemon that raised the row when the machine itself is the actor (`eventType` = client kind).
export function activityMachineId(row: {
  eventType: string;
  sourceId?: string | null;
  actorId: string | null;
  actorName?: string | null;
  detail?: unknown;
}): string | undefined {
  if (row.eventType === "daemon_offline" && !row.actorId) return row.sourceId || undefined;
  const daemonId = (row.detail as { daemonId?: unknown } | null | undefined)?.daemonId;
  if (!row.actorId && typeof daemonId === "string" && daemonId) return daemonId;
  // The quiet-worker notice: signed by its daemon, which is also its subject.
  const signed = !!row.actorName && row.actorName !== "Someone";
  if (row.eventType === "system_notice" && signed && row.actorId && row.actorId === row.sourceId) {
    return row.actorId;
  }
  return undefined;
}

// A daemon the viewer's roster lacks cannot be told apart, so it draws as the laptop.
export function machineKindFor(
  machineId: string,
  daemonById: (id: string) => { worker?: unknown } | undefined,
): MachineKind {
  return daemonById(machineId)?.worker ? "workspace" : "personal";
}
